import { combineReducers } from 'redux';
import CategoryReducer from './CategoryReducer';
import CategoryRowReducer from './CategoryRowReducer';
import SearchReducer from './SearchReducer';
import ModulesReducer from './ModulesReducer';


export default combineReducers({
  categories: CategoryReducer,
  tableCategories: CategoryRowReducer,
  search: SearchReducer,
  ModulesTable: ModulesReducer,
});
